if (!window.customElements.get('gtc-faq-search')) {
    class GtcFaqSearch extends HTMLElement {
        constructor() {
            super();
            // Add any initialization code here

            this.dom = {
                searchInput: this.querySelector('input[type="search"]'),
            }

            this.settings = {
                searchableElements: null,
            }
        }

        connectedCallback() {
            // Add any code to run when the element is added to the DOM
            this.settings.searchableElements = this.GetSearchableElements();
            this.AddEventlisteners();
        }

        disconnectedCallback() {
            // Add any code to run when the element is removed from the DOM
            this.RemoveEventlisteners();
        }

        GetSearchableElements() {
            return document.querySelectorAll('gtc-faq-item');
        }

        AddEventlisteners() {
            this.dom.searchInput.addEventListener('keyup', this.Debounce(() => {
                this.LiveSearch();
            }, 300));

            this.dom.searchInput.addEventListener('search', this.Debounce(() => {
                this.LiveSearch();
            }, 300));

        }

        RemoveEventlisteners() {
            this.dom.searchInput.removeEventListener('keyup', this.Debounce(() => {
                this.LiveSearch();
            }, 300));

            this.dom.searchInput.removeEventListener('search', this.Debounce(() => {
                this.LiveSearch();
            }, 300));
        }

        Debounce(func, wait, immediate) {
            let timeout;
            return function() {
                let context = this,
                    args = arguments;
                let later = function() {
                    timeout = null;
                    if (!immediate) func.apply(context, args);
                };
                let callNow = immediate && !timeout;
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
                if (callNow) func.apply(context, args);
            };
        }


        LiveSearch() {
            let search_queries = this.dom.searchInput.value.split(' ');
            //Remove empty strings
            search_queries = search_queries.filter(function(el) {
                return el != "";
            });

            for (var i = 0; i < this.settings.searchableElements.length; i++) {

                // if this.settings.searchableElements[i] contains one of the search queries
                let queryMatches = 0;

                for (var j = 0; j < search_queries.length; j++) {
                    if (this.settings.searchableElements[i].textContent.toLowerCase()
                        .includes(search_queries[j].toLowerCase())) {
                        queryMatches++;
                    }
                }

                if (queryMatches === search_queries.length) {
                    this.settings.searchableElements[i].classList.remove("hidden");
                } else {
                    this.settings.searchableElements[i].classList.add("hidden");
                }
            }
        }

    }

    customElements.define('gtc-faq-search', GtcFaqSearch);
}
